// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.laborder.LoincCodeResponse */
/* istanbul ignore next */
@GandalfModel
export class LoincCodeResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	loincNum!: string | null;

	@GandalfProperty({ designType: String })
	longCommonName!: string | null;

	@GandalfProperty({ designType: String })
	shortName!: string | null;

}
